import { api } from '../configs/axiosConfigs';

export const getPropertyModelColumns = async () => {
  return await api.get('/table_settings.json');
};
